import {
  MarkerAction,
  MARKER_ACTION_APPEND,
  MARKER_ACTION_MODIFY,
  MARKER_TOOL_ACTION_SET_STYLE,
  MARKER_ACTION_DELETE,
} from '../actions/MarkerAction';
import { findIndex } from '../../../../../common/src/ts/utils';
import { AppStates } from '../../../../..';
import { SelectionType } from '../../reducers/selection';

export interface MarkerToolState {
  colorIndex: number;
}

export function initMarkerToolState(): MarkerToolState {
  return {
    colorIndex: 0,
  };
}

export function markerReducer(state: AppStates, action: MarkerAction): AppStates {
  switch (action.type) {
    case MARKER_ACTION_APPEND: {
      return {
        ...state,
        markers: [...state.markers, action.info],
        selectionState: {
          type: SelectionType.MARKER,
          id: action.info.id,
        },
      };
    }
    case MARKER_ACTION_DELETE: {
      const markers = state.markers.filter(info => info.id !== action.id);
      return {
        ...state,
        markers,
        selectionState: {
          type: SelectionType.NONE,
        },
      };
    }
    case MARKER_ACTION_MODIFY: {
      const index = findIndex(state.markers, info => info.id === action.info.id);
      if (index < 0) {
        return state;
      }
      const markers = state.markers.slice();
      markers[index] = { ...state.markers[index], ...action.info };
      return { ...state, markers };
    }
    case MARKER_TOOL_ACTION_SET_STYLE: {
      return { ...state, markerTool: { colorIndex: action.colorIndex } };
    }
    default:
      return state;
  }
}
